/* eslint-disable react-hooks/rules-of-hooks */
import * as React from 'react';
import {withSystem, TypeImplementation} from '@packages/systems/wfdl';
import {
  type ContextualExpression,
  ContextualExpressions,
} from '@packages/utilities/contextual-expression';
import {
  ExpressionEditor,
  extendExpressionEditorActionAtPath,
} from '@packages/systems/ExpressionEditor-utils';

import {TNumber, TRecord} from '@packages/systems/wfdl-ast';

const {getIn} = ContextualExpressions;

const exprToLatLng = (expr: ContextualExpression) =>
  getIn(expr, [{in: 'Record', at: 'gpslatlong'}]);

// The `gpslatlong` field is added as artificial complexity to demonstrate the
// functionality of our ExpressionEditor from context rendering a Record
// expression and updating the sub fields correctly.
export const GPS = TypeImplementation.Alias({
  type: TRecord({
    gpslatlong: TRecord({
      lat: withSystem({isBindable: false}, TNumber),
      long: withSystem({isBindable: false}, TNumber),
    }),
  }),
  render: ({expr, dispatch}) => {
    const [latLong, setLatLong] = React.useState(exprToLatLng(expr));
    React.useEffect(() => {
      const nextLatLong = exprToLatLng(expr);
      if (nextLatLong !== latLong) {
        setLatLong(nextLatLong);
      }
    }, [expr, latLong]);
    if (!latLong) return null;
    const onLatLongChange = extendExpressionEditorActionAtPath(dispatch)([
      {in: 'Record', at: 'gpslatlong'},
    ]);
    return <ExpressionEditor dispatch={onLatLongChange} expression={latLong} />;
  },
});
